<template>
    <div class="main">
        <my_menu></my_menu>

        <div class="content">
            <div class="" style="height:50px">
                <Alert type="warning"> 项目部门下方添加用户后，可以有部门所有项目权限，无需单独添加项目权限
                </Alert>
            </div>
            <div class="options_box">
                <Button type="primary" size="small" style="font-size:10px" @click="click_total_auth">添加所有权限</Button>
            </div>

            <div class="table_box">
                <Spin fix size="large" v-if="table_loading"></Spin>

                <div v-for="(item, i) in dep_list" :key="i" class="dep_list">
                    <div class="team_title">
                        {{ item.label }}
                    </div>
                    <div class="children_box">

                        <div class="dep_inner_box" v-for="(children_item, children_index) in item.children"
                            :key="children_index">

                            <div class="dep_main_div">
                                <div class="depname">
                                    {{ children_item.label }}
                                </div>
                                <div class="add_user_btn" @click="click_user_add(children_item)">
                                    <Icon type="md-add-circle" />添加
                                </div>
                            </div>
                            <div class="">
                                <div class="user_list_div">
                                    <Tag closable style="margin:0 10px 5px 0" color="success"
                                        @on-close="close_tag(user_item, children_item)"
                                        v-for="(user_item, user_index) in children_item.user_list">{{
                                            user_item.name }}</Tag>
                                </div>

                            </div>

                        </div>


                    </div>

                </div>
            </div>

        </div>

        <Modal v-model="add_user_show" title="添加用户" :footer-hide="true" width="400">
            <div>
                <Select v-model="add_select_user_id" filterable>
                    <Option v-for="item in user_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="add_user_btn_div">
                <Button type="primary" @click="click_add_user_affirm">确认添加</Button>

            </div>
        </Modal>

        <Modal v-model="add_user_total_show" title="添加用户(所有部门)" :footer-hide="true" width="400">
            <div>
                <Select v-model="add_select_user_id" filterable>
                    <Option v-for="item in user_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="add_user_btn_div">
                <Button type="primary" @click="click_add_total_user_affirm">确认添加</Button>

            </div>
        </Modal>
    </div>
</template>

<script>
import my_menu from '@/component/menu/menu.vue'
import { http } from "@/utils/http.js";

export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            dep_list: [],
            table_loading: false,
            user_list: [],
            add_user_show: false,
            add_select_user_id: '',
            add_user_dep_id: '',
            add_user_total_show: false,
        }
    },

    mounted() {
        this.window_change()
        this.get_dep_list()
        this.get_user_list()
    },

    methods: {
        //添加所有部门
        click_add_total_user_affirm() {
            if (this.add_select_user_id.length < 10) {
                this.$Message.error('请选择用户')
                return
            }

            var that = this
            var obj = {
                user_id: this.add_select_user_id,
                dep_id: 'all'
            }
            http("post", process.env.VUE_APP_HOST + "/project_manage/dep_auth/add_user", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_dep_list()
                        that.add_user_total_show = false

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        click_total_auth() {
            this.add_user_total_show = true
        },

        close_tag(user_item, children_item) {
            var that = this
            this.$Modal.confirm({
                title: '提示',
                content: '<p>正在删除，是否继续？</p>',
                onOk: () => {
                    that.close_tag_ok(user_item, children_item)
                },
                onCancel: () => {

                }
            });
        },

        close_tag_ok(user_item, children_item) {

            var that = this
            var obj = {
                dep_id: children_item.value,
                user_id: user_item.user_id

            }
            http("post", process.env.VUE_APP_HOST + "/project_manage/dep_auth/del_user", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_dep_list()
                        that.add_user_show = false

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })

        },

        click_add_user_affirm() {
            if (this.add_select_user_id.length < 10) {
                this.$Message.error('请选择用户')
                return
            }

            var that = this
            var obj = {
                user_id: this.add_select_user_id,
                dep_id: this.add_user_dep_id
            }
            http("post", process.env.VUE_APP_HOST + "/project_manage/dep_auth/add_user", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_dep_list()
                        that.add_user_show = false

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })

        },


        click_user_add(item) {
            this.add_user_dep_id = item.value
            this.add_user_show = true
        },

        get_user_list() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/project_manage/dep_auth/user_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.user_list = res.data.user_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        get_dep_list() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/project_manage/dep_auth/dep_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.dep_list = res.data.dep_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        click_copy(str) {
            this.$Copy({
                text: str
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.add_user_btn_div {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
}

.depname {
    font-weight: 600;
    font-size: 13px;
    padding: 5px 5px;
    border-radius: 3px;
}

.add_user_btn {
    font-size: 13px;
    margin-left: 10px;
    cursor: pointer;
    color: #ccc;
}

.add_user_btn:hover {
    color: #0466dd;
}

.user_list_div {
    display: flex;
    flex-wrap: wrap;
    margin: 0 10px 10px 15px;
}


.dep_inner_box {
    margin-bottom: 10px;
    border: 1px solid #eeeeee;


}

.team_title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    margin-bottom: 10px;
    cursor: pointer;
}

.children_dep {
    margin: 10px;
    border: 1px solid #ccc;
    color: #666;
    padding: 3px 8px;
    font-size: 13px;
    cursor: pointer;
    width: 100px;
    border-radius: 3px;
}

.children_dep2 {
    margin: 10px;
    border: 1px solid #ccc;
    color: #666;
    display: flex;
    align-items: center;
    padding: 3px 8px;
    font-size: 12px;
    border-radius: 3px;
    cursor: pointer;
}

.children_dep2:hover {
    background-color: #0466dd;
    color: #fff
}

.dep_main_div {
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;
}

.dep_list {
    border-bottom: 10px solid #f5f7f9;
    padding: 10px 10px 0 10px;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.options_box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 10px;
}

.table_box {
    position: relative;
    height: calc(100vh - 90px);
    overflow: auto;
    ;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    width: calc(100% - 180px);
    background-color: #fff;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
}

.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>